import { DailyActivityItem } from "../types/types";

export interface ExportItem {
  date: string;
  NAUBurn: number;
  NAUYMint: number;
  NAUNMint: number;
}

export default function transformStatsForExport(
  data: DailyActivityItem[]
): ExportItem[] {
  return data.map((item) => ({
    date: item.date,
    NAUBurn: item.NAU ?? 0,
    NAUYMint: item.NAUY ?? 0,
    NAUNMint: item.NAUN ?? 0,
  }));
}
